// Ana sayfa "Haftalık Görev Durumu Dağılımı" pasta grafiği rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'dashboard.weeklyTaskStatus';

export const weeklyTaskStatusGuide = (t: TFunction): GuideContent => ({
  layout: 'chart',
  title: t(`${G}.title`, 'Haftalık Görev Durumu Dağılımı nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu grafik, haftalık görevlerin durumlarına göre dağılımını gösterir. Her dilim bir durumdur; haftalık görevler görev bazında (her görev bir kez) sayılır. Altındaki açıklamada her durumun toplamdaki yüzdesi yazar, dilimin üzerine gelince görev sayısını görürsünüz. Sayısı sıfır olan durumlar grafikte görünmez.'),
  chart: {
    kind: 'pie',
    legend: [
      { color: '#4CAF50', label: t(`${G}.l1.label`, 'Tamamlanan'), text: t(`${G}.l1.text`, 'Başarıyla tamamlanan haftalık görevlerin sayısı.') },
      { color: '#1976D2', label: t(`${G}.l2.label`, 'Devam Eden'), text: t(`${G}.l2.text`, 'Personel tarafından kabul edilmiş, çalışması devam eden (etkin) haftalık görevlerin sayısı.') },
      { color: '#F44336', label: t(`${G}.l3.label`, 'Tamamlanmamış'), text: t(`${G}.l3.text`, 'Süresi geçtiği halde tamamlanmamış (kaçırılan) haftalık görevlerin sayısı.') },
    ],
    note: t(`${G}.note`, 'Şube yöneticisi olarak giriş yaptıysanız grafik yalnız kendi şubenizin görevlerini gösterir.'),
  },
});
